(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-the-room"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const closeAll = (section, except) => {
      section.querySelectorAll('[data-room-popover]').forEach((popover) => {
        if (popover !== except) popover.hidden = true;
      });
      section.querySelectorAll('[data-room-pin]').forEach((pin) => {
        const controlled = document.getElementById(pin.getAttribute('aria-controls'));
        pin.setAttribute('aria-expanded', controlled === except ? 'true' : 'false');
      });
    };

    const positionPopover = (pin, popover) => {
      const stage = pin.closest('.shop-room__stage');
      const anchor = pin.querySelector('.shop-room__pin-dot') || pin;
      if (!stage || !anchor || popover.hidden) return;

      const stageRect = stage.getBoundingClientRect();
      const anchorRect = anchor.getBoundingClientRect();
      const margin = 10;
      const gap = 11;
      const popoverWidth = popover.offsetWidth;
      const popoverHeight = popover.offsetHeight;
      const halfWidth = popoverWidth / 2;
      const anchorCenterX = anchorRect.left - stageRect.left + (anchorRect.width / 2);
      const minimumX = halfWidth + margin;
      const maximumX = stage.clientWidth - halfWidth - margin;
      const left = Math.min(Math.max(anchorCenterX, minimumX), Math.max(minimumX, maximumX));
      const below = anchorRect.bottom - stageRect.top + gap;
      const above = anchorRect.top - stageRect.top - popoverHeight - gap;
      const fitsBelow = below + popoverHeight <= stage.clientHeight - margin;
      const top = fitsBelow ? below : Math.max(margin, above);

      popover.style.left = `${left}px`;
      popover.style.top = `${top}px`;
      popover.style.bottom = 'auto';
      popover.style.transform = 'translateX(-50%)';
      popover.dataset.placement = fitsBelow ? 'below' : 'above';
    };

    const lockPinOrigin = (pin) => {
      if (!pin) return;
      const mobile = window.matchMedia('(max-width: 749px)').matches && pin.closest('.shop-room--immersive');
      pin.style.setProperty('left', `var(${mobile ? '--pin-mobile-x' : '--pin-x'})`, 'important');
      pin.style.setProperty('top', `var(${mobile ? '--pin-mobile-y' : '--pin-y'})`, 'important');
      pin.style.setProperty('transform', 'translate3d(-50%, -50%, 0)', 'important');
    };

    document.querySelectorAll('[data-room-pin]').forEach((pin) => {
      lockPinOrigin(pin);
      pin.addEventListener('pointerenter', () => lockPinOrigin(pin));
      pin.addEventListener('pointerleave', () => lockPinOrigin(pin));
      pin.addEventListener('focus', () => lockPinOrigin(pin));
    });

    document.addEventListener('click', (event) => {
      const pin = event.target.closest('[data-room-pin]');
      if (pin) {
        const section = pin.closest('.shop-room');
        const popover = document.getElementById(pin.getAttribute('aria-controls'));
        if (!section || !popover) return;
        const willOpen = popover.hidden;
        closeAll(section, willOpen ? popover : null);
        popover.hidden = !willOpen;
        pin.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
        if (willOpen) positionPopover(pin, popover);
        return;
      }

      const closeButton = event.target.closest('[data-room-close]');
      if (closeButton) {
        const section = closeButton.closest('.shop-room');
        if (section) closeAll(section, null);
        return;
      }

      document.querySelectorAll('.shop-room').forEach((section) => {
        if (!section.contains(event.target)) closeAll(section, null);
      });
    });

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      document.querySelectorAll('.shop-room').forEach((section) => closeAll(section, null));
    });

    let roomResizeFrame;
    window.addEventListener('resize', () => {
      window.cancelAnimationFrame(roomResizeFrame);
      roomResizeFrame = window.requestAnimationFrame(() => {
        document.querySelectorAll('[data-room-pin][aria-expanded="true"]').forEach((pin) => {
          const popover = document.getElementById(pin.getAttribute('aria-controls'));
          if (popover) positionPopover(pin, popover);
        });
      });
    });

    document.addEventListener('click', async (event) => {
      const button = event.target.closest('[data-shop-look-add]');
      if (!button || button.disabled) return;

      const status = button.parentElement.querySelector('[data-shop-look-status]');
      const originalHtml = button.innerHTML;
      button.disabled = true;
      if (status) status.textContent = button.dataset.loadingLabel || '';

      try {
        const items = JSON.parse(button.dataset.items || '[]');
        if (!items.length) throw new Error('No available items');

        const response = await fetch(button.dataset.addUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({ items })
        });

        if (!response.ok) {
          const error = await response.json().catch(() => ({}));
          throw new Error(error.description || error.message || 'Cart error');
        }

        document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
        window.location.assign(button.dataset.cartUrl);
      } catch (error) {
        button.disabled = false;
        button.innerHTML = originalHtml;
        if (status) status.textContent = button.dataset.errorLabel || '';
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shoppable-hero"] && !Shopify.designMode) return;
  try {
    
  class PampasShoppableHero extends HTMLElement {
    connectedCallback() {
      this.abortController = new AbortController();
      const signal = this.abortController.signal;
      this.lockMobileHeroViewport();
      this.initHeroRotation();
      window.addEventListener('orientationchange', () => {
        window.setTimeout(() => this.lockMobileHeroViewport(true), 250);
      }, { signal });
      window.addEventListener('resize', () => {
        const currentWidth = document.documentElement.clientWidth;
        if (currentWidth !== this.mobileViewportWidth) this.lockMobileHeroViewport(true);
      }, { passive: true, signal });
      if (window.theme && window.theme.sections) {
        this.initQuickShop();
      } else {
        document.addEventListener('page:loaded', () => this.initQuickShop(), { once: true, signal });
      }
      if (this.querySelector('pm-popover')) {
        window.addEventListener('scroll', () => {
          this.querySelectorAll('pm-popover:popover-open').forEach(p => p.hidePopover());
        }, { passive: true, signal });
      }
      if (!Shopify.designMode) return;
      document.addEventListener('shopify:section:load', (event) => {
        if (event.target.contains(this)) this.initQuickShop();
      }, { signal });
      this.addEventListener('shopify:block:select', (event) => {
        this.initQuickShop();
        const btn = event.target.querySelector('button');
        if (btn) btn.click();
      }, { signal });
      this.addEventListener('shopify:block:deselect', (event) => {
        const popover = event.target.querySelector('pm-popover');
        if (popover) popover.hidePopover?.();
      }, { signal });
    }

    initHeroRotation() {
      const slides = Array.from(this.querySelectorAll('.pm-shoppable-hero__slide'));
      if (slides.length < 2) return;
      let activeIndex = Math.max(0, slides.findIndex((slide) => slide.classList.contains('is-active')));
      const syncActiveSlide = (previousIndex = null) => {
        if (previousIndex !== null && previousIndex !== activeIndex) {
          const incomingSlide = slides[activeIndex];
          incomingSlide.classList.add('is-resetting');
          incomingSlide.classList.remove('is-active', 'is-leaving');
          void incomingSlide.offsetWidth;
          incomingSlide.classList.remove('is-resetting');
        }
        slides.forEach((slide, index) => {
          const isActive = index === activeIndex;
          const isLeaving = previousIndex !== null && index === previousIndex && !isActive;
          slide.classList.toggle('is-active', isActive);
          slide.classList.toggle('is-leaving', isLeaving);
          slide.style.removeProperty('opacity');
          slide.style.removeProperty('visibility');
          slide.style.setProperty('pointer-events', isActive ? 'auto' : 'none', 'important');
          slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
        });
        const holidayActive = slides[activeIndex].classList.contains('pm-shoppable-hero__slide--holiday');
        this.classList.toggle('is-holiday-slide', holidayActive);
        const hotspots = this.querySelector('.pm-shoppable-hero__hotspots');
        if (hotspots) {
          hotspots.style.setProperty('opacity', holidayActive ? '0' : '1', 'important');
          hotspots.style.setProperty('visibility', holidayActive ? 'hidden' : 'visible', 'important');
          hotspots.style.setProperty('pointer-events', holidayActive ? 'none' : '', holidayActive ? 'important' : '');
        }
      };
      syncActiveSlide();
      this.heroRotationTimer = window.setInterval(() => {
        const previousIndex = activeIndex;
        activeIndex = (activeIndex + 1) % slides.length;
        syncActiveSlide(previousIndex);
      }, 5000);
    }

    disconnectedCallback() {
      this.abortController?.abort();
      window.clearInterval(this.heroRotationTimer);
    }

    lockMobileHeroViewport(force = false) {
      const hero = this.querySelector('.pm-content-over-media');
      if (!hero) return;
      const isMobile = window.matchMedia('(max-width: 699px)').matches;
      if (!isMobile) {
        hero.style.removeProperty('--pm-shoppable-hero-height');
        this.mobileViewportWidth = document.documentElement.clientWidth;
        return;
      }
      const currentWidth = document.documentElement.clientWidth;
      if (!force && this.mobileViewportHeight && currentWidth === this.mobileViewportWidth) return;
      this.mobileViewportWidth = currentWidth;
      this.mobileViewportHeight = window.innerHeight;
      hero.style.setProperty('--pm-shoppable-hero-height', `${this.mobileViewportHeight}px`);
    }

    initQuickShop() {
      if (!theme.settings.quickView) return;
      var sectionEl = this.closest('[id^="shopify-section-"]');
      var links = this.querySelectorAll('.shoppable-hero__popover-link[data-product-handle]');
      if (!links.length) return;
      links.forEach(link => {
        if (link.dataset.shoppableHeroBound === 'true') return;
        link.dataset.shoppableHeroBound = 'true';
        var handle = link.dataset.productHandle;
        var productId = link.dataset.productId;
        if (!document.getElementById('QuickShopModal-' + productId)) return;
        link.addEventListener('click', (event) => {
          if (theme.config.bpSmall) {
            event.stopImmediatePropagation();
            return;
          }
          const popover = event.target.closest('pm-popover');
          if (popover) popover.hidePopover?.();
        }, true);
        var hotspot = link.closest('.pm-shoppable-hero__hotspot');
        if (!hotspot) return;
        var preloadOnce = function() {
          if (link.dataset.shoppableHeroPreloaded === 'true') return;
          if (theme.config.bpSmall) return;
          var holder = document.getElementById('QuickShopHolder-' + handle);
          if (holder && sectionEl) {
            var holderSection = holder.closest('[id^="shopify-section-"]');
            if (holderSection && holderSection !== sectionEl) {
              var duplicate = sectionEl.querySelector('#QuickShopModal-' + productId);
              if (duplicate) duplicate.remove();
            }
          }
          link.dataset.shoppableHeroPreloaded = 'true';
          link.classList.add('js-modal-open-quick-modal-' + productId);
          theme.preloadProductModal(handle, productId, link);
          hotspot.removeEventListener('mouseover', preloadOnce);
          hotspot.removeEventListener('focusin', preloadOnce);
        };
        hotspot.addEventListener('mouseover', preloadOnce);
        hotspot.addEventListener('focusin', preloadOnce);
      });
    }
  }

  customElements.define('pm-shoppable-hero', PampasShoppableHero);

  } catch(e) { console.error(e); }
})();
})();
